import "../assets/css/ClassicApp.css";

export default function ClassicFaucetAppContainer(
  props: React.PropsWithChildren<{ className: string }>,
) {
  return <div className={props.className}>{props.children}</div>;
}
